import React, { createContext, useState, useContext, useEffect } from 'react';
import bastionAuth from '../services/bastionAuthService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      // Vérifier si l'utilisateur est authentifié via Bastion
      const isValid = await bastionAuth.verifyToken();
      
      if (isValid) {
        const currentUser = await bastionAuth.getCurrentUser();
        setUser(currentUser);
        setIsAuthenticated(true);
      } else {
        // Rediriger vers Bastion si non authentifié
        bastionAuth.logout();
      }
    } catch (error) {
      console.error('Erreur lors de la vérification de l\'authentification:', error);
      bastionAuth.logout();
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    bastionAuth.logout();
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};